
import { FundSearchRequestModel } from '@alcon-db-models/FundSearchRequestModel';
import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { DataBindingDirective, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { FilterDescriptor } from '@progress/kendo-data-query';
import { SandboxFileUploadSearchService } from '@services/sandbox-file-upload-search.service';
import { UserPreferencesService } from '@services/user-preferences.service';
import { Subscription } from 'rxjs';
import { JsonUtilities } from '../shared/json-utilities';
import { SelectSearchBindingBaseDirective } from './select-search-binding.base.directive';
import { UserPreferenceEnabledDataBindingDirective } from './user-preference-enabled-data-binding.directive';
import { SandboxFileUploadSearchRequestModel } from '@alcon-db-models/SandboxFileUploadSearchRequestModel';

@Directive({
  selector: '[sandboxFileUploadSearchBinding]'
})
export class SandboxFileUploadSearchBindingDirective  extends UserPreferenceEnabledDataBindingDirective implements OnInit, OnDestroy {

  @Input() preferenceKey: string = "SandboxFileUploadSearch";

  private serviceSubscription?: Subscription;

  constructor(
    grid: GridComponent,
    userPreferencesService: UserPreferencesService,
    changeDetectorRef: ChangeDetectorRef,
    public SandboxFileUploadSearchService: SandboxFileUploadSearchService
    ) {
    super(grid, userPreferencesService, changeDetectorRef);
  }

  public ngOnInit(): void {

    this.SandboxFileUploadSearchService.next([] as any as GridDataResult);

    this.serviceSubscription = this.SandboxFileUploadSearchService.subscribe((result) => {
      
      result = JsonUtilities.convertDatesAndCopy(result);

      this.grid.loading = false;
      this.grid.data = result;
      this.notifyDataChange();
      this.grid.loading = false;
    });

    super.ngOnInit();
  }

  public ngOnDestroy(): void {
    if (this.serviceSubscription) {
        this.serviceSubscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  public rebind(): void {
    this.grid.loading = true;
    this.SandboxFileUploadSearchService.query(this.getSearchRequest());
  }

  public resetPage(): void {
    this.state.skip = 0;
    this.rebind();
  }

  public getSearchRequest(doIgnorePagination: boolean = false): SandboxFileUploadSearchRequestModel {

    const request = <SandboxFileUploadSearchRequestModel>{};
    const filters: FilterDescriptor[] = this.state.filter?.filters as FilterDescriptor[];
    // TODO: all directives should enumerate filters (like below) instead of hard coding them.  Create base search directive?
    filters?.forEach(x => { if (typeof(x.field) === 'string') { (request as any)[x.field] = x.value; }});

    return ({
      ...request,
      personID: null,
      take: doIgnorePagination ? null : this.state.take,
      skip: doIgnorePagination ? 0 : this.state.skip,
      sortColumn: this.state.sort?.[0]?.dir ? this.state.sort?.[0]?.field : null,
      sortAscending: this.state.sort?.[0]?.dir ? this.state.sort[0].dir != 'desc' : null,
    });
  }
}

